import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_RESET_DATA",
    parentId: "SETTINGS_PARENT",
    applicationRights: Rights,
    title: 'Resett data',
    text: 'Resett data',
    canShowOnDashboard: false,
});
